import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';

import { Done } from '../asset';
import { joinCn } from '../util';
import style from './style';
import type { VToggleButtonProps } from './type';

const VToggleButton = forwardRef(
  (props: VToggleButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
      isSelected,
      className,
      children,
      size = 'md',
      fluid,
      ...buttonProps
    } = props;

    return (
      <button
        className={joinCn(style.filterChip(isSelected, size), className, {
          'w-full!': !!fluid,
        })}
        ref={ref}
        type="button"
        {...buttonProps}
      >
        {isSelected && <Done className={style.icon(size)} />}
        <span className={style.text}>{children}</span>
      </button>
    );
  },
);

VToggleButton.displayName = 'VToggleButton';

export default VToggleButton;
